
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowRight, Film } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface PlaylistCardProps {
  playlist: {
    id: string | number;
    name: string;
    channelName: string;
    thumbnailUrl: string;
    count?: number;
  };
}

// Use a named export for the component
export const PlaylistCard = ({ playlist }: PlaylistCardProps) => {
  return (
    <Link to={`/playlist/${playlist.id}`} className="block no-underline" draggable={false}>
      <Card className="h-full overflow-hidden border transition-shadow duration-300 hover:shadow-md">
        <div className="relative overflow-hidden">
          <AspectRatio ratio={2/3}>
            <img 
              src={playlist.thumbnailUrl} 
              alt={playlist.name} 
              className="w-full h-full object-cover"
              draggable={false}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300" />
            <div className="absolute bottom-3 right-3 bg-white/90 dark:bg-black/70 text-primary rounded-full p-2 shadow-md opacity-0 hover:opacity-100 transition-opacity duration-300">
              <ArrowRight className="h-4 w-4" />
            </div>
          </AspectRatio>
        </div>
        <CardHeader className="p-3 pb-2">
          <CardTitle className="text-base line-clamp-1 text-center hover:text-primary transition-colors duration-300">
            {playlist.name}
          </CardTitle>
          <CardDescription className="line-clamp-1 text-xs text-center">
            <span className="inline-flex items-center justify-center">
              <Film className="h-3 w-3 mr-1" /> {playlist.channelName}
            </span>
          </CardDescription>
        </CardHeader>
      </Card>
    </Link>
  );
};

// Also export as default to maintain backward compatibility
export default PlaylistCard;
